<template>
  <div id="forgot-password" class="login-type-page">
    <img class="main-logo-mobile" src="@/assets/svg/Logo_Horizontal_Gradient_Dark_Transparent.svg" alt="logo" />
    <main>
      <div class="content">
        <h2>{{ $t("reset-password.forgot-title") }}</h2>
        <div v-if="!resetting">
          <form id="reset-form" @submit.prevent="reset">
            <p class="reset-msg">{{ $t("reset-password.forgot-msg") }}</p>
            <custom-input
              :inputType="'email'"
              v-model="email"
              :name="'email'"
              :label="'Email'"
              :placeholder="'your@email.com'"
              :focusInputField="true"
              boxed
            />
            <button class="btn-login" type="submit">
              {{ $t("reset-password.forgot-btn") }}
            </button>
          </form>
        </div>
        <div v-else>
          <p class="email-sent-msg">{{ $t("reset-password.email-sent-msg") }}</p>
        </div>
        <div class="to-login" v-if="!resetting">
          <router-link :to="{ name: 'login' }">{{ $t("reset-password.to-login") }} login</router-link>
        </div>
      </div>
    </main>
    <aside>
      <div class="content">
        <img class="main-logo" src="@/assets/svg/Logo_Horizontal_Gradient_Dark_Transparent.svg" alt="logo" />
        <h1>{{$t('login.forgot-password.sideview.title')}}</h1>
        <h3>{{$t('login.forgot-password.sideview.sub-title')}}</h3>
        <div class="visual">
          <span><i class="fa-light fa-umbrella-beach"></i></span>
        </div>
        <h4>{{$t('login.forgot-password.sideview.sub-title-2')}}</h4>
        <p>{{$t('login.forgot-password.sideview.description')}}</p>
      </div>
    </aside>
  </div>
</template>
<script>
import CustomInput from "@/components/CustomInput";
export default {
  name: "forgotPassword",
  data() {
    return {
      email: "",
      resetting: false,
      error: false
    };
  },
  methods: {
    reset(evt) {
      evt.preventDefault();
      this.resetting = true;
      this.$store.dispatch("sendResetPassword", this.email).then(
        () => {},
        (error) => {
          this.error = true;
          this.resetting = false;
        }
      );
    }
  },
  mounted() {
    if (this.$store.token) this.$router.push("/");
  },
  components: { CustomInput }
};
</script>

<style lang="less">
#forgot-password.login-type-page {
  h1 {
    margin-bottom: 12px;
    font-size: clamp(24px, 5vh, 46px);
    color: var(--charcoal);
  }
  h2 {
    font-size: 24px;
  }
  h3 {
    font-size: 18px;
  }

  .main-logo-mobile {
    width: 180px;
    margin-bottom: 48px;
  }
}

#forgot-password {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    form {
      width: 300px;

      .reset-msg {
        margin-top: 12px;
      }
      .btn-login {
        margin-top: 26px;
      }
    }
  }
  .to-login {
    font-size: 12px;
    text-align: center;
    margin: 36px 0 0 0;
    a {
      color: var(--charcoal-50);
      text-decoration: underline;
    }
  }
  aside {
    display: none;
  }
}

@media only screen and (min-width: 900px) {
  #forgot-password {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .to-signup-mobile {
      display: none;
    }
    .main-logo {
      display: block;
    }
    .main-logo-mobile {
      display: none;
    }

    main {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    aside {
      height: 100vh;
      width: clamp(400px, 40vw, 550px);
      background: var(--signup-aside);
      // padding: 0 20px 0 80px;
      box-shadow: inset 2px 0px 4px rgba(0, 0, 0, 0.05);
      display: flex;
      flex-direction: column;
      justify-content: center;

      .content {
        min-height: 310px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .visual {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 200px;
        font-size: 80px;
        color: var(--orange-web);
        opacity: 0.75;
      }
      p {
        width: 250px;
        text-align: center;
      }
      .main-logo {
        display: block;
        margin-left: -8px;
        width: 180px;
      }
    }
  }
}
@media only screen and (min-width: 900px) {
  #forgot-password {
    main {
      form {
        width: 400px;
      }
    }
  }
}
</style>
